export default __webpack_public_path__ + "static/media/bolt.a7b9573b.svg";